import DeltaWrapper from 'quill-delta'

export const Delta = DeltaWrapper
export const emptyTextArea = JSON.stringify(new DeltaWrapper())
export const emptyTextAreaString: string = '{"ops":[]}'
